<template>
  <ul v-show="mouseInfo.visible" :style="getPositionInfo" class="context-menu">
    <!--区分光标和选择文字-->
    <template v-if="((mouseInfo.type) === 'source')">
      <!--右键-->
      <template v-if="!(mouseInfo.selectText)">
        <li @click="() => handleCopyToTarget(mouseInfo)">复制原文到译文</li>
        <li @click="() => handleClear(mouseInfo)">清除译文</li>
        <li @click="() => handleAddRemark(mouseInfo)">添加备注</li>
        <li @click="() => handleSplitFrangment(mouseInfo)">拆分</li>
        <li @click="() => handleDownMerge(mouseInfo)">向下合并</li>
      </template>
      <!--划词-->
      <template v-if="mouseInfo.selectText">
        <li class="set-font" @click="handleClick($event)" v-if="false">
          <div class="set-font-inside">
            <span>字体设置</span>
            <i class="icon">➤</i>
          </div>
          <div class="children-menu">
            <p>粗体</p>
            <p>斜体</p>
            <p>下划线</p>
            <p>删除线</p>
          </div>
        </li>
        <li v-if="getUrlTypeInfo !== 'school'" @click="handleSearchMemory($event)">在翻译记忆库中搜索</li>
        <li @click="() => handleClickSearch()">在网页中搜索</li>
        <li v-if="getUrlTypeInfo !== 'school'" @click="() => handleAddTerm('second')">添加术语库</li>
        <li v-if="false">复制/粘贴</li>
      </template>
    </template>
    <template v-if="((mouseInfo.type) === 'target')">
      <!--右键-->
      <template v-if="!(mouseInfo.selectText)&&!mouseInfo.markType && mouseInfo.showClearTatget">
        <li @click="()=>handleClear(mouseInfo)">清除译文</li>
        <li @click="()=>handleAddRemark(mouseInfo)">添加备注</li>
      </template>
      <!--划词-->
      <template v-if="((mouseInfo.selectText) || (!(getUrlTypeInfo==='school')))&&!mouseInfo.markType">
        <li class="set-font" @click="handleClick($event)" v-if="false">
          <div class="set-font-inside">
            <span>字体设置</span>
            <i class="icon">➤</i>
          </div>
          <div class="children-menu">
            <p>粗体</p>
            <p>斜体</p>
            <p>下划线</p>
            <p>删除线</p>
          </div>
        </li>
        <!-- <li v-if="editorMode">ssssss</li> -->
        <li v-if="!editorMode" @click="() => handleClickSearch()">
          在网页中搜索
        </li>
        <li v-if="false">复制/粘贴</li>
      </template>
      <template v-if="mouseInfo.markType">
        <li @click="reviseBtn(true)">接受修订</li>
        <li @click="reviseBtn(false)">拒绝修订</li>
      </template>
    </template>
    <template v-if="((mouseInfo.type) === 'lock')">
      <!--右键-->
      <li @click="() => handleUnLock(mouseInfo)">解除锁定</li>
      <li @click="() => handleUnLockAll(mouseInfo)">解除全部锁定</li>
    </template>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "MouseRight",
  props: {
    mouseInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visibleRemarks: false,
      editorMode: false
    };
  },
  computed: {
    ...mapGetters('editor', [
      'getThemeInfo',                // 主题信息
      'getUrlInfo',                  // 获取路由信息
      'getTaskContentListParams',    // 列表接口基础参数
    ]),
    getPositionInfo: function () {
      //不使用命名空间
      let positionInfo = this.$store.getters["editor/getPositionInfo"];
      return { ...positionInfo };
    },
    ...mapGetters("editor", [
      "getEditorModeInfo", // 当前编辑器模式 标准/修订
      "getFileTaskInfo", // 文件任务信息
      "getFileInfo" // 文件信息
    ]),
    //获取原译文修改
    getTargetContentInfo() {
      return this.$store.getters["editor/getFilePreviewContentInfo"];
    },

    //获取url信息
    getUrlTypeInfo() {
      const urlInfo = this.$store.getters["editor/getUrlInfo"];
      if (!!urlInfo && !!urlInfo.type) {
        return urlInfo.type;
      }
      return "";
    },
    getModifyRecordList: function () {
      let modifyRecordInfo = this.$store.getters["editor/getModifyRecordInfo"];
      console.log(modifyRecordInfo);
      if (
        Reflect.has(modifyRecordInfo, "result") &&
        !!modifyRecordInfo.result
      ) {
        return modifyRecordInfo.result;
      } else {
        return [];
      }
    }
  },
  watch: {
    getEditorModeInfo: {
      handler() {
        this.editorMode = this.getEditorModeInfo === "mark" ? true : false;
      },
      immediate: true
    },
    getTargetInfo: {
      handler(val) {
        console.log(val);
        if (val.targetTagFragmentVo) {
          let domArr = document.querySelectorAll(
            `span[type = 'target'][sid = '${val.sentId}']`
          );
          if (domArr[0]) {
            this.getLoopNode(domArr[0]);
          } else {
            let keyDomArr = document.querySelectorAll(
              `span[type = 'target'][key = '${this.getSentCountInfo.key}']`
            );
            if (keyDomArr[0]) {
              this.getLoopNode(keyDomArr[0]);
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    Cancel(info, type) {
      console.log(info);
      console.log(this.$store.state)
      //type为1：接受   为2：拒绝
      let item = info.currentItem;
      let targetTemp = {};
      Reflect.set(targetTemp, "sort", 0);
      Reflect.set(targetTemp, "text", null);
      Reflect.set(targetTemp, "type", null);
      Reflect.set(
        targetTemp,
        "atoms",
        info.data.filter(item => typeof item == "object")
      );
      // targetTemp.atoms.forEach(item => {
      //   if(item.data !== info.selectText){
      //     this.$message.warning("请选择修改语句")
      //   }
      // })
      let params = {
        companyCode: info.currentItem.companyCode,
        content: info.data.content,
        costTime: info.costTime,
        fileId: info.getFileTaskInfo.fileId,
        isCommitVersio: 0,
        isSaveVersion: 0,
        platformType: this.$platformType,
        sentId: info.currentItem.id,
        sourceAppid: "",
        sourceTagFragmentVo: null,
        status: info.currentItem.status,
        targetTagFragmentVo: targetTemp,
        taskId: info.getFileTaskInfo.id,
        taskType: info.getFileTaskInfo.taskType,
        transModel: 0
      };
      // const highlightTerms = {}
      //     if (row.sourceTermSent && row.sourceTermSent.length) {
      //       highlightTerms.sourceTermSent = row.sourceTermSent
      //     }
      //     if (row.targetTermSent && row.targetTermSent.length) {
      //       highlightTerms.targetTermSent = row.targetTermSent
      //     }
      let paramsInfo = {};
      Reflect.set(paramsInfo, "params", params);
      Reflect.set(paramsInfo, "type", info.updataType);
      Reflect.set(paramsInfo, "activeName", info.editorBottomActiveNameInfo);
      // Reflect.set(paramsInfo, "highlightTerms", highlightTerms);
      console.log(paramsInfo);
      if (type === 1) {
        let html = document.getElementById(`target-${item.id}`).innerHTML;
        console.log(html)
        let arr = Array.from(document.getElementsByClassName("insert"))
        arr.forEach(item => {
          if (item.innerText === info.selectText) {
            item.classList.remove("insert", "del")
          }
        })
      } else if (type === 2) {
        console.log(info);
      }
    },

    handleClick(e) {
      console.log(`${e.clientX + 10}px`);
      console.log(`${e.clientY + 10}px`);
    },

    //复制到译文
    handleCopyToTarget(info) {
      const self = this;
      if (Reflect.has(info, "type") && info.type === "source") {
        let item = info.currentItem;
        let urlInfo = self.$store.getters["editor/getUrlInfo"];
        let fileId = 0;
        if (urlInfo.type === "project") {
          let fileInfo = self.$store.getters["editor/getFileInfo"];
          fileId = fileInfo.id;
        } else if (urlInfo.type === "task" || urlInfo.type === "school") {
          let fileTaskInfo = self.$store.getters["editor/getFileTaskInfo"];
          fileId = fileTaskInfo.fileId;
        }

        let source =
          document.getElementById(`source-${item.id}`).innerHTML || "";
        // document.getElementById(`target-${item.id}`).innerHTML = source;
        // //重新机翻成功后再做一次译文的更新处理
        let params = Object();
        Reflect.set(params, "constTime", 0);
        Reflect.set(params, "taskId", null);
        Reflect.set(params, "taskType", null);
        Reflect.set(params, "isSaveVersion", 1);
        Reflect.set(params, "sentId", item.id);
        Reflect.set(params, "content", source);
        Reflect.set(params, "status", item.status);
        Reflect.set(params, "fileId", fileId);
        if (item.tagSourceSent) {
          let targetTemp = Object();
          let SourceTag = JSON.parse(item.tagSourceSent).fragments[0].atoms;
          Reflect.set(targetTemp, "sort", 0);
          Reflect.set(targetTemp, "text", null);
          Reflect.set(targetTemp, "type", null);
          Reflect.set(targetTemp, "atoms", SourceTag);
          Reflect.set(params, "sourceTagFragmentVo", null);
          Reflect.set(params, "targetTagFragmentVo", targetTemp);
        }
        self.$store.dispatch("editor/updateTargetInfo", {
          params: params,
          type: 1
        });
      }
    },
    //添加术语
    handleAddTerm(value) {
      let editorModeInfo = this.$store.getters["editor/getEditorModeInfo"];
      const self = this;
      if (editorModeInfo === "standard") {
        let keyword = self.mouseInfo.selectText;
        // 选中文字后弹出菜单点击添加术语原文赋值为 鼠标选中后右击选中的
        let params = {
          column: value,
          keyword: keyword
        };
        this.$store.dispatch("editor/setOerationSignInfo", params);
      } else {
        this.$message.closeAll();
        this.$message({
          message:
            "当前正处在修订模式无法进行添加术语操作,请先切换回标准模式下进行该操作.",
          type: "warning"
        });
      }
    },
    //添加批注信息
    handleAddRemark(param) {
      // 批注弹出-调用父级的方法-关闭右键
      let params = {
        id: param.id,
        sourceSent: param.currentItem.sourceSent,
        sourceWordNum: param.currentItem.sourceWordNum
      };
      this.$emit('handleRemarks', params)
    },
    reviseBtn(bool) {
      this.$emit('reviseBtn', bool)
    },
    //网页检索
    handleClickSearch() {
      const self = this;
      let searchKeyword = self.mouseInfo.selectText;
      if (searchKeyword) {
        searchKeyword = encodeURIComponent(
          searchKeyword.replace(/\u00a0/g, " ")
        );
        const search = parseInt(self.$store.getters["editor/getSearchInfo"]);
        const getUrlInfo = this.$store.getters["editor/getUrlInfo"];
        switch (search) {
          case 1:
            window.open(`https://www.baidu.com/s?wd=${searchKeyword}`);
            break;
          case 2:
            window.open(`https://www.google.com/search?q=${searchKeyword}`);
            break;
          case 3:
            window.open(`https://www.sogou.com/web?query=${searchKeyword}`);
            break;
          case 4:
            window.open(`https://cn.bing.com/search?q=${searchKeyword}`);
            break;
          case 5:
            window.open(`http://www.iciba.com/word?w=${searchKeyword}`);
            break;
          case 6:
            window.open(
              `https://youdao.com/result?word=${searchKeyword}&lang=${getUrlInfo.sourceLang}`
            );
            break;
        }
      }
    },
    //清空译文
    handleClear(info) {
      const self = this;
      let item = info.currentItem;
      let fileId = 0;
      let urlInfo = self.$store.getters["editor/getUrlInfo"];
      if (urlInfo.type === "project") {
        let fileInfo = self.$store.getters["editor/getFileInfo"];
        fileId = fileInfo.id;
      } else if (urlInfo.type === "task" || urlInfo.type === "school") {
        let fileTaskInfo = self.$store.getters["editor/getFileTaskInfo"];
        fileId = fileTaskInfo.fileId;
      }
      document.getElementById(`target-${item.id}`).innerHTML = "";
      let params = Object();
      Reflect.set(params, "constTime", 0);
      Reflect.set(params, "taskId", null);
      Reflect.set(params, "taskType", null);
      Reflect.set(params, "isSaveVersion", 1);
      Reflect.set(params, "sentId", item.id);
      Reflect.set(params, "content", "");
      Reflect.set(params, "status", item.status);
      Reflect.set(params, "fileId", fileId);
      Reflect.set(params, "sourceTagFragmentVo", null);

      let targetTemp = Object();
      Reflect.set(targetTemp, "atomKey", item.templateKey);
      Reflect.set(
        targetTemp,
        "sort",
        `${parseInt(item.id.toString().substr(0, 5))}`
      );
      Reflect.set(targetTemp, "data", "");
      Reflect.set(targetTemp, "style", null);
      Reflect.set(targetTemp, "id", item.id);
      Reflect.set(targetTemp, "dataType", "text");
      Reflect.set(targetTemp, "tagType", "text");
      let atomsTemp = Array();
      atomsTemp.push(targetTemp);
      let targetTempTag = Object();
      Reflect.set(targetTempTag, "atoms", targetTempTag);
      Reflect.set(targetTempTag, "sort", 0);
      Reflect.set(targetTempTag, "text", null);
      Reflect.set(targetTempTag, "type", null);

      Reflect.set(params, "targetTagFragmentVo", {
        atoms: atomsTemp,
        sort: 0,
        text: null,
        type: null
      });
      self.$store.dispatch("editor/updateTargetInfo", {
        params: params,
        type: 5
      });
    },
    //拆分原文
    handleSplitFrangment() {
      const self = this;
      let editorMode = localStorage.getItem("editorMode");
      if (editorMode === "mark") {
        this.$message.closeAll();
        this.$message.warning("修订模式下，不能进行拆分操作");
        return;
      }
      let tempInfo = self.$store.getters["editor/getTempSentenceIdInfo"];
      let fileId = 0;
      let urlInfo = self.$store.getters["editor/getUrlInfo"];
      if (urlInfo.type === "project") {
        let fileInfo = self.$store.getters["editor/getFileInfo"];
        fileId = fileInfo.id;
      } else if (urlInfo.type === "task" || urlInfo.type === "school") {
        let fileTaskInfo = self.$store.getters["editor/getFileTaskInfo"];
        fileId = fileTaskInfo.fileId;
      }
      // let getSourceeditStatus = self.$store.getters["editor/getSourceeditStatus"];
      // if (getSourceeditStatus === true) {
      let cursorPositionInfo =
        self.$store.getters["editor/getCursorPositionInfo"];
      if (tempInfo.type === "source" && !!cursorPositionInfo.length) {
        let params = Object();
        cursorPositionInfo.pop();
        Reflect.set(params, "sentId", tempInfo.item.id);
        Reflect.set(params, "transFileId", fileId);
        Reflect.set(params, "transFileSentList", cursorPositionInfo);
        self.$store.dispatch("editor/splitFragment", params).finally(() => {
          self.$store.dispatch("editor/recordCursorPosition", {});
          self.$store.dispatch("editor/setTempSentenceId", {});
          // if ((urlInfo.type) === 'project') {
          //        let taskContentListParams = self.$store.getters['editor/getTaskContentListParams'];
          //        Reflect.set(taskContentListParams, 'startSort', 1);
          //        self.$store.dispatch("editor/getFileContent",taskContentListParams);
          //        }else{
          //        let taskContentListParams = self.$store.getters['editor/getTaskContentListParams'];
          //        Reflect.set(taskContentListParams, 'startSort', 1);
          //        self.$store.dispatch("editor/getTaskContent",taskContentListParams);
          //    }
        });
      } else {
        self.$message({
          message: "请先将光标定位到原文",
          type: "warning"
        });
      }
      // } else {
      //   self.$message.closeAll();
      //   self.$message({
      //     message: '请先点击编辑原文，再进行拆分操作',
      //     type: 'warning'
      //   });
      // }
    },
    //向下合并
    handleDownMerge() {
      const self = this;
      let editorMode = localStorage.getItem("editorMode");
      if (editorMode === "mark") {
        this.$message.closeAll();
        this.$message.warning("修订模式下，不能进行拆分操作");
        return;
      }
      let tempInfo = self.$store.getters["editor/getTempSentenceIdInfo"];
      let fileId = 0;
      let urlInfo = self.$store.getters["editor/getUrlInfo"];
      if (urlInfo.type === "project") {
        let fileInfo = self.$store.getters["editor/getFileInfo"];
        fileId = fileInfo.id;
      } else if (urlInfo.type === "task" || urlInfo.type === "school") {
        let fileTaskInfo = self.$store.getters["editor/getFileTaskInfo"];
        fileId = fileTaskInfo.fileId;
      }
      //  let getSourceeditStatus=self.$store.getters["editor/getSourceeditStatus"];
      // if(getSourceeditStatus===true){
      if (tempInfo.type === "source") {
        //获取当前句的的dom--获取句子的父级--获取当前句子兄弟
        let currentId = tempInfo.item.id;
        let dom = document.getElementById(`source-${currentId}`);
        let parentNodeDom = dom.parentNode.parentNode;
        let parentNodeNextDom = parentNodeDom.nextSibling;
        let nextId = parentNodeNextDom.getAttribute("infoid");
        let params = Object();
        Reflect.set(params, "sourceSentId", currentId);
        Reflect.set(params, "targetSentId", parseInt(nextId));
        Reflect.set(params, "transFileId", fileId);
        self.$store.dispatch("editor/mergeFragment", params).then(() => {
          self.$store.dispatch("editor/recordCursorPosition", {});
          self.$store.dispatch("editor/setTempSentenceId", {});
          if (urlInfo.type === "project") {
            let taskContentListParams =
              self.$store.getters["editor/getTaskContentListParams"];
            self.$store.dispatch(
              "editor/getFileContent",
              taskContentListParams
            );
          } else {
            let taskContentListParams =
              self.$store.getters["editor/getTaskContentListParams"];
            self.$store.dispatch(
              "editor/getTaskContent",
              taskContentListParams
            );
          }
        });
      } else {
        self.$message({
          message: "请先将光标定位到原文",
          type: "warning"
        });
      }
      // }else{
      //   self.$message.closeAll();
      //     self.$message({
      //     message: '请先点击编辑原文，再进行合并操作',
      //     type: 'warning'
      //   });
      // }
    },
    //在记忆库中搜索
    handleSearchMemory() {
      const self = this;
      let params = Object();
      let searchKeyword = self.mouseInfo.selectText;
      let fileId = 0;
      let urlInfo = self.$store.getters["editor/getUrlInfo"];
      if (urlInfo.type === "project") {
        let fileInfo = self.$store.getters["editor/getFileInfo"];
        fileId = fileInfo.id;
      } else if (urlInfo.type === "task" || urlInfo.type === "school") {
        let fileTaskInfo = self.$store.getters["editor/getFileTaskInfo"];
        fileId = fileTaskInfo.fileId;
      }
      if (searchKeyword) {
        Reflect.set(params, "sourcePar", searchKeyword);
        Reflect.set(params, "fileId", fileId);
        Reflect.set(params, "sourceIndex", searchKeyword.length);
        self.$nextTick(() => {
          self.$store.dispatch("editor/setSentMemoryInfo", params);
        });
      } else {
        self.$message({
          message: "先选中要检索的句段",
          type: "warning"
        });
      }
    },
    //解除锁定
    handleUnLock(info) {
      let item = info.currentItem
      console.log(item);
      const { type, fileId, taskType, projectId ,taskId} = this.getUrlInfo
      let params = Object();
      Reflect.set(params, 'projectId', projectId);
      Reflect.set(params, 'sentId', (item.id));
      Reflect.set(params, 'taskType', taskType);
      //获取任务信息
      const marker = type === 'project' ? 2 : 1
      const data = {
        ...this.getTaskContentListParams,
        marker,
        comparedHighlight: 0,
        showTerm: 1,
        transFileId: fileId,
        taskType: taskType || 1,
        taskId,
      }
      this.$store.dispatch('editor/unLockOne', { params, data })

    },
    //解除全部锁定
    handleUnLockAll(info) {
      let item = info.currentItem
      console.log(item);
      const { type, fileId, taskType, projectId } = this.getUrlInfo
      let params = Object();
      Reflect.set(params, 'fileId', fileId);
      Reflect.set(params, 'projectId', projectId);
      Reflect.set(params, 'taskType', taskType);
      //获取任务信息
      const marker = type === 'project' ? 2 : 1
      const data = {
        ...this.getTaskContentListParams,
        marker,
        comparedHighlight: 0,
        showTerm: 1,
        transFileId: fileId,
        taskType: taskType || 1,
      }
      this.$store.dispatch('editor/unLockAll', { params, data })

    },
  },
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
